import {
  PRACTICEAREALIST_FETCHITEMS_LOAD,
  PRACTICEAREALIST_FETCHITEMS_SUCCEED,
  PRACTICEAREALIST_FETCHITEMS_FAIL,
  PRACTICEAREALIST_CHANGETABLE_CHANGE,
  PRACTICEAREALIST_SEARCHTABLE_EDIT,
  PRACTICEAREALIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PRACTICEAREALIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case PRACTICEAREALIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case PRACTICEAREALIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case PRACTICEAREALIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case PRACTICEAREALIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case PRACTICEAREALIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
